import React from "react";
import { ZoomOut } from "lucide-react";
import { Text } from "@jasperlabs/ui";

function NoPermissionPage() {
	return (
		<div className="mx-auto my-12 w-full max-w-container-lg rounded-md">
			<div className="flex min-h-[30vh] flex-col items-center justify-center p-8 text-center">
				<ZoomOut className="mb-4 h-4 w-4 shrink-0 text-neutral-500" />
				<Text as="h2" variant="heading-xs" className="text-neutral-800">
					You don&apos;t have permission to access this.
				</Text>
			</div>
		</div>
	);
}

export default NoPermissionPage;
